import ReactMarkdown from "react-markdown";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { vscDarkPlus } from "react-syntax-highlighter/dist/esm/styles/prism";
import type { StrapiRichTextBlock } from "../types";

interface RichTextBlockProps {
  block: StrapiRichTextBlock;
}

export const RichTextBlock = ({ block }: RichTextBlockProps) => {
  return (
    <div className="prose prose-sm dark:prose-invert max-w-none [&_pre]:mb-4">
      <ReactMarkdown
        components={{
          code({ className, children, ...props }: any) {
            const match = /language-(\w+)/.exec(className || "");
            const inline = !match;
            return !inline ? (
              <div className="relative rounded-2xl overflow-hidden mb-4">
                <span className="absolute top-2 right-3 bg-white/10 text-white/70 px-2 py-1 rounded text-xs font-semibold uppercase z-10">
                  {match[1]}
                </span>
                <SyntaxHighlighter
                  style={vscDarkPlus as any}
                  language={match[1]}
                  PreTag="div"
                  customStyle={{
                    margin: 0,
                    borderRadius: "16px",
                  }}
                >
                  {String(children).replace(/\n$/, "")}
                </SyntaxHighlighter>
              </div>
            ) : (
              <code className={className} {...props}>
                {children}
              </code>
            );
          },
        }}
      >
        {block.body}
      </ReactMarkdown>
    </div>
  );
};
